import styles from './DeleteModal.module.scss';

interface IDeleteModalProps {
  handleConfirm: () => void;
  handleCancel: () => void;
  title?: string;
  body?: string;
  confirmLabel?: string;
}

function DeleteModal({ handleConfirm, handleCancel, title, body, confirmLabel }: IDeleteModalProps) {
  return (
    <div className={styles.dialogBackground}>
      <div className={styles.dialog}>
        <div className={styles.title}>{title || <>Are you sure you want to delete this?</>}</div>
        <div className={styles.text}>{body || <>This item will be archived and the action cannot be undone.</>}</div>
        <div className={styles.buttonRow}>
          <button className={`${styles.button} ${styles.white}`} onClick={handleCancel}>
            Cancel
          </button>
          <button className={styles.button} onClick={handleConfirm}>
            {confirmLabel || 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteModal;
